import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { postAvatar } from '@/auth/api';
import { useAuth } from '@/auth/use-auth';
import { PlayerAvatar } from '@/components/prototype/player-avatar';
import { BevelWindow } from '@/components/prototype/bevel-window';
import { Button } from '@/components/ui/button';

export function AvatarSection() {
  const { t } = useTranslation('auth');
  const { user, refresh } = useAuth();
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const displayName = user ? (user.display_name ?? user.name) : '';

  const handleFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      await postAvatar(file);
      await refresh();
      toast.success(t('settings.avatarSaved'));
    } catch {
      toast.error(t('errors.generic'));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <BevelWindow title={t('settings.avatar')}>
      <div className="flex items-center gap-4">
        <PlayerAvatar name={displayName} src={user?.avatar} size={64} />
        <div>
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/gif,image/webp"
            className="hidden"
            onChange={handleFile}
          />
          <Button
            type="button"
            variant="outline"
            disabled={uploading}
            onClick={() => inputRef.current?.click()}
          >
            {t('settings.avatarUpload')}
          </Button>
        </div>
      </div>
    </BevelWindow>
  );
}
